import {
  CCard,
  CCardBody,
  CSmartTable,
  CButton,
  CSpinner,
  CCardHeader,
  CCardFooter,
} from "@coreui/react-pro";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Collapsible from "react-collapsible";
import {
  setActivities,
  setCreatedActivityId,
  setSelectedActivities,
} from "src/Slices/activitySlice";
import {
  GET_ACTIVITIES,
  GET_ACTIVITIES_FOR_ODRPREVIEW,
  GET_ACTIVITIES_FOR_PARENT_CHILD,
  GET_SELECTED_ACTIVITY,
} from "src/setup/apollo/queries";
import { GetCurrentSelectedActivityEvaluaterReport } from "src/setup/Utils/utils";
import { dateOf, getStartAndEndOfWeek } from "src/setup/helper/dataHelper";
import { useDispatch, useSelector } from "react-redux";
import { useApolloClient } from "@apollo/client";
import AuthService from "src/components/modules/auth/redux/AuthService";
import { cilSend } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import DownloadFile from "src/setup/helper/donwloadFile";
import { useLoading } from "src/contexts/LoadingContext";
import { runFastPublish } from "src/setup/helper/mutationHelper";
import { API_URL } from "src/setup/helper/apiUrl";
import { useDropzone } from "react-dropzone";
import ReactDropzone from "../ReactDropzone";
import cogoToast from "cogo-toast";
import { modelUpdateMutationCreator } from "src/setup/helper/mutationHelper";
import { UPDATE_ACTIVITY_FROM_EMPTY } from "src/setup/apollo/mutations";
import Swal from "sweetalert2";

function EvaluatorReport() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { showLoading, hideLoading } = useLoading();
  const [allDataResultActtivities, setAllDataResultActtivities] = useState([]);
  const [allDataResultActtivitiesTemp, setAllDataResultActtivitiesTemp] =
    useState([]);
  const [users, setUsers] = useState([]);
  const [isFetchFinished, setIsFetchFinished] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [filteredDataActivities, setFilteredDataActivities] = useState();
  const [submitButtonDisable, setSubmitButtonDisable] = useState(false);

  const [selectedDate, setSelectedDate] = useState(dateOf(new Date()));
  const salesPersonGuid = AuthService.GetCurrentUser().salesPersonGuid;

  const activityReducer = useSelector((state) => state.activityReducer);
  const [statuForwardResponse, setStatuForwardResponse] = useState();

  const selectedActivityStatementsfromGet =
    GetCurrentSelectedActivityEvaluaterReport();
  const selectedActivityStatements = JSON.parse(
    selectedActivityStatementsfromGet
  );
  const applications = activityReducer.activityIndex;

  const salesPersonName = AuthService.GetCurrentUser().salesPersonName;


  function handleDownlaodButton(item) {
    /* console.log("item", item);
    const url0 = API_URL;
    const url = `/api/Documents/Download?fileGuid=${item.item.document.guid}&backup=false`;
    const parts = item?.item?.document?.fileName.split(".");
    const contentType = parts[parts.length - 1];
    const fileName = item?.item?.document.originalFileName + "." + contentType;
    console.log(fileName, "FileName");
    DownloadFile(url0, url, fileName); */
    const url0 = API_URL;
    const url = `/api/Documents/Download?fileGuid=${item.document.guid}&backup=false`;
    if (
      item?.document?.originalFileName.includes(".docx") ||
      item?.document?.originalFileName.includes(".pdf") ||
      item?.document?.originalFileName.includes(".rar") ||
      item?.document?.originalFileName.includes(".zip") ||
      item?.document?.originalFileName.includes(".xlsx") ||
      item?.document?.originalFileName.includes(".txt") ||
      item?.document?.originalFileName.includes(".xls") ||
      item?.document?.originalFileName.includes(".doc") ||
      item?.document?.originalFileName.includes(".jpg") ||
      item?.document?.originalFileName.includes(".png") ||
      item?.document?.originalFileName.includes(".svg") ||
      item?.document?.originalFileName.includes(".bmg") ||
      item?.document?.originalFileName.includes(".pptx") ||
      item?.document?.originalFileName.includes(".ppt")
    ) {
      DownloadFile(url0, url, item?.document?.originalFileName, showLoading, hideLoading);
    } else {
      const parts = item?.document?.fileName.split(".");
      const contentType = parts[parts.length - 1];
      const fileName = item.document.originalFileName + "." + contentType;
      DownloadFile(url0, url, fileName, showLoading, hideLoading);
    }
  }
  const toActivityStatusIDInAccept = 626;

  const dateModel = getStartAndEndOfWeek(selectedDate);

  let startOfWeek = dateModel.startOfWeek;
  let endOfWeek = dateModel.endOfWeek;

  const applicationsGuidArrays = activityReducer.activitiesByWeek[startOfWeek];

  let TableData = [];
  const createdActivityId = activityReducer.createdActivityId;

  const _activityTypeGuid = "07EF8AFD-4944-4DB0-9773-E9A0A0CBD9CB";
  const client = useApolloClient();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loading) loadActivities();
  }, []);

  useEffect(() => {
    if (statuForwardResponse != undefined) setSubmitButtonDisable(true);
    if (statuForwardResponse != undefined) {
      const id =
        statuForwardResponse.data.updateActivityStatus.activity.activityId;
    }
  }, [statuForwardResponse]);

  async function loadActivities() {
    setLoading(true);

    var cursor = undefined;
    var buffer = [];

    async function query() {
      let result = await _loadDataAtCursor(cursor);
      if (result.error || result?.data?.activities?.edges == undefined) {
        return false;
      }
      const pi = result.data?.activities?.pageInfo;
      if (!pi) return false;
      let activities = result.data.activities.edges.map((r) => r.node);
      buffer.push(...activities);
      cursor = pi.endCursor;
      return pi.hasNextPage;
    }

    var hasMore = true;
    while (hasMore === true) {
      hasMore = await query();
    }
    setIsFetchFinished(true);
    let _isFromReload = createdActivityId == null ? true : false;

    setAllDataResultActtivities(buffer);
    dispatch(
      setActivities({
        key: startOfWeek,
        activities: buffer,
        isFromReload: _isFromReload,
      })
    );
    if (!_isFromReload) dispatch(setCreatedActivityId(undefined));

    setLoading(false);
  }

  function statuForward(element, updateVersion) {
    const toStatus =
      element.activityStatus.activityStatusWorkflowToActivityStatusesWf.find(
        (element) => element.isDefault == true
      );
    runFastPublish(
      element.guid,
      updateVersion,
      toStatus.toActivityStatusId,
      element.activityStatusId,
      element.activityType.workflow.workflowId,
      "note child app form statu ",
      client,
      setStatuForwardResponse
    );
  }

  const _loadDataAtCursor = async (cursor) => {
    try {
      return await client.query({
        query: GET_ACTIVITIES_FOR_PARENT_CHILD,
        variables: {
          cursor,
          //  salesPersonGuid: salesPersonGuid,
          activityTypeGuid: _activityTypeGuid,
        },
      });
    } catch (e) {
      console.log("erroring", e);
    }
  };

  const [degerlendirici, setDegerlendirici] = useState("");

  useEffect(() => {}, [degerlendirici]);

  useEffect(() => {
    if (!activityReducer) {
      SetCurrentActivitiesData(activityReducer);
    }
  }, [activityReducer]);
  // 59e89455-2450-46cf-a17e-54ae329400ca status guid to filter
  useEffect(() => {
    console.log("allDataResultActtivities", allDataResultActtivities);
    let tempArrayParent = [];
    let tempArrayNotFilteredParent = [];
    let tempArrayChild = [];
    let parentArray = [];
    if (allDataResultActtivities != undefined) {
      allDataResultActtivities.map((item) => {
        if (
          item?.activityStatements[7]?.value?.includes(salesPersonName) ||
          item?.activityStatements[16]?.value?.includes(salesPersonName) ||
          item?.activityStatements[17]?.value?.includes(salesPersonName) ||
          item?.activityStatements[18]?.value?.includes(salesPersonName) ||
          item?.activityStatements[19]?.value?.includes(salesPersonName)
        )
          parentArray.push(item);
      });

      parentArray.map((element) => {
        //console.log("İlk gelen veri", allDataResultActtivities);
        const filteredChild = element.childActivities.find(
          (el) =>
            el.activityStatus.guid == "2bcc90c1-6ac9-4a6a-9a9d-422073dc3abc"
        );
        console.log("filteredChild", filteredChild);
        if (filteredChild != undefined) {
          tempArrayParent.push(element);
        }
      });
    }
    setDegerlendirici(tempArrayParent[0]?.activityStatements[16]?.value);
    console.log(
      tempArrayParent[0]?.activityStatements[16]?.value,
      "LLLLLLLLLLLLLLLLLL"
    );
    console.log("Temp Array Parent", tempArrayParent);
    tempArrayParent.map((element) =>
      element.childActivities?.forEach((el) => tempArrayChild.push(el))
    );
    //filtered about activitystatusid and all child of parents put just one array
    console.log("temp Array Child", tempArrayChild);
    setFilteredDataActivities(tempArrayChild);

    setAllDataResultActtivitiesTemp(allDataResultActtivities);
  }, [allDataResultActtivities]);

  function GetChildByIndex(index) {
    let tempArray = [];
    console.log("Everybody Lets Go");
    const newFilteredDataActivities = filteredDataActivities.filter(
      (element) =>
        element.activityStatus.guid == "2bcc90c1-6ac9-4a6a-9a9d-422073dc3abc"
    );
    console.log("newFilteredDataActivities", newFilteredDataActivities);
    const parentDoc = filteredDataActivities[index].activityDocuments;
    console.log("----------parentDoc---------", parentDoc);
    const doc = parentDoc.filter(
      (el) => el.activityStatement.statementCode == "D1"
    );
    console.log("doc", doc);
    for (let i = 0; i < doc.length; i++) {
      const newelement = doc[i];
      let object = {
        id: "",
        program: "",
        creator: "",
        date: "",
        status: "",
        guid: "",
        document: "",
        item: newelement,
      };

      const program = filteredDataActivities[index]?.activityStatements?.find(
        (element) => element.statementCode == "B1"
      );
      const creator = degerlendirici;
      object.program =
        program?.value == null ? "Veri bulunamadı." : program?.value;
      object.creator = creator == null ? "Veri bulunamadı." : creator;
      object.date = filteredDataActivities[index]?.planDateTime?.slice(0, 10);
      object.id = newelement.documentId;
      object.status = newelement.document.originalFileName;
      object.guid = newelement.document.guid;
      tempArray.push(object);
    }
    return tempArray;
  }

  return (
    <>
      {loading ? (
        <CSpinner color="warning" size="sm" className="bg-transparent" />
      ) : (
        ""
      )}
      {loading ? <span> Lütfen Bekleyiniz...</span> : ""}
      {/* <div>Hakan</div> */}
      {filteredDataActivities?.map((element, key) => (
        <>
          <EvaluatorReportComponent
            key={key}
            element={element}
            index={key}
            GetChildByIndex={GetChildByIndex}
            statuForward={statuForward}
            handleDownlaodButton={handleDownlaodButton}
            statuForwardResponse={statuForwardResponse}
          />
        </>
      ))}
      {/* <>
      {allDataResultActtivities?.map((element,index)=>(
        <EvaluatorReport data={element} key={index} index={index}/>
      ))}</> */}
    </>
  );
}

export default EvaluatorReport;

const EvaluatorReportComponent = (props) => {
  const [isActive, setIsActive] = useState(true);
  const [submitButtonDisable, setSubmitButtonDisable] = useState(false);
  const {
    element,
    index,
    GetChildByIndex,
    statuForward,
    handleDownlaodButton,
    statuForwardResponse,
  } = props;

  const [updateVersion, setUpdateVersion] = useState(element?.updateVersion);
  const [updated, setUpdated] = useState(0);

  useEffect(() => {
    async function getUpdateVersion() {
      try {
        const response = await client.query({
          query: GET_SELECTED_ACTIVITY,
          variables: {
            activityGuid: element.guid,
          },
        });
        console.log(response?.data?.activities?.edges[0]?.node?.updateVersion);
        setUpdateVersion(
          response?.data?.activities?.edges[0]?.node?.updateVersion
        );
      } catch (error) {}
    }
    getUpdateVersion();
  }, [updated]);

  const client = useApolloClient();

  useEffect(() => {
    console.log("Mamma Mia", element);
    console.log("statuForwardResponse 90", statuForwardResponse);
    if (statuForwardResponse != undefined) {
      const id =
        statuForwardResponse.data.updateActivityStatus.activity.activityId;
      id == element.activityId && setSubmitButtonDisable(true);
    }
  }, [statuForwardResponse]);

  const [programFiles, setProgramFiles] = useState([]);
  const [mutationResponse, setMutationResponse] = useState("");

  const activtyDocumentModel = () => {
    if (programFiles != []) {
      let emptyActivityStatementList = [];
      let object = {
        notes: "",
        statementCode: "",
        value: "Yüklendi",
        emptyDocumentModels: [],
      };

      programFiles.map((element, index) => {
        let emptyDocumentModelstemp = {
          tusFileName: "",
          fileName: "",
          extension: "",
          documentTypeCode: "",
        };
        object.statementCode = "D4";
        const extensionArray = element.name.split(".");
        console.log("extensionArray", extensionArray);
        const newname = element.name.split(".");
        newname.pop();
        newname.join("-");
        emptyDocumentModelstemp.fileName = newname[0];

        emptyDocumentModelstemp.tusFileName = tusFiles.find(x=>x.fileName==element.name).tusFileName;
        emptyDocumentModelstemp.extension =
          extensionArray[extensionArray.length - 1];

        emptyDocumentModelstemp.documentTypeCode = "D";
        if (emptyDocumentModelstemp.fileName != "")
          object.emptyDocumentModels.push(emptyDocumentModelstemp);
        object.value = "Yüklendi";
      });

      console.log("emptyActivityStatementList", emptyActivityStatementList);
      emptyActivityStatementList.push(object);
      return modelUpdateMutationCreator(
        updateVersion,
        element?.activityType?.guid,
        element?.guid,
        emptyActivityStatementList
      );
    } else {
      return "error";
    }
  };

  async function sendIt() {
    try {
      const response = await updateActivityDocument();
      setUpdated(updated + 1);
      console.log(response, "Response for UpdateDocument");
      /* const response2 = await statuForward(element);
      console.log(response2, "Response for Statü"); */
    } catch (error) {
      console.log(error);
    }
  }

  const updateActivityDocument = async () => {
    let model = activtyDocumentModel();
    if (model == "error") {
      console.log(model);
      console.log("Model oluşiturulamadı.");
    } else {
      try {
        console.log("model göndermeden önce console", model);
        let response = await client.mutate({
          mutation: UPDATE_ACTIVITY_FROM_EMPTY,
          variables: { model },
        });
        let stringify = JSON.stringify(response);
        let parsed = JSON.parse(stringify);
        let rep = parsed.data.updateActivityFromEmptyActivity;
        if (response == undefined) {
          setMutationResponse(undefined);

          cogoToast.success("Form Güncellenemedi!");
          return "FAIL";
        } else {
          console.log("rep");
          setMutationResponse(rep);

          cogoToast.success("Form Gönderildi!");
        }
        if (response.errors != null) {
          cogoToast.success("Form Güncellenemedi!");

          setMutationResponse(undefined);
        } else {
        }
      } catch (error) {
        console.log("update errror", error);

        setMutationResponse(undefined);

        console.log("model error", model);
        cogoToast.error("Program güncellenemedi!");
      }
    }
  };

  const role = AuthService.GetCurrentUser()?.userData.roles;

  const [tusFiles, setTusFiles] = useState([]);

  function manageFileName(item) {
    setTusFiles((prevTusFiles)=>[...prevTusFiles,item]);  
  }

  return (
    <div key={"report " + index}>
      {element?.activityStatus?.guid ==
        "2bcc90c1-6ac9-4a6a-9a9d-422073dc3abc" && (
        <CCard className="mb-5 text-dark" key={index}>
          <CCardHeader
            className="fw-bold position-relative "
            style={{
              background: "#c8dfff",
              color: "#262626",
            }}
          >
            Rapor Bilgileri
            <span className="position-absolute end-0 me-4">
              {isActive ? (
                <button
                  className="btn btn-warning py-0  mb-3 py-0 me-1 btn-remove-active "
                  type="button"
                  onClick={() => setIsActive(!isActive)}
                >
                  <i className="bi bi-arrow-left-circle"></i>
                </button>
              ) : (
                <button
                  className="btn btn-warning py-0  mb-3 me-1 mb-2 btn-remove-active  "
                  type="button"
                  onClick={() => setIsActive(!isActive)}
                >
                  <i className="bi bi-arrow-down-circle"></i>
                </button>
              )}
            </span>
          </CCardHeader>
          <CCardBody style={{ background: "rgb(236, 225, 190,0.3)" }}>
            <div className="d-flex justify-content-center border-top border-end border-start rounded w-100 ">
              <table
                className="w-100"
                style={{
                  border: "2px solid black",
                  background: "rgb(247, 237, 203)",
                }}
              >
                <thead>
                  <tr>
                    <td style={tdHeadStyle} className=" fw-bold">
                      Başvuru No
                    </td>
                    <td style={tdHeadStyle} className=" fw-bold">
                      Kurum
                    </td>
                    <td style={tdHeadStyle} className=" fw-bold">
                      Fakülte
                    </td>
                    <td style={tdHeadStyle} className=" fw-bold">
                      Durum
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={tdStyle}>{element.activityId}</td>
                    <td style={tdStyle}>
                      {element.activityStatements[0]?.value}
                    </td>
                    <td style={tdStyle}>
                      {element.activityStatements[1]?.value}
                    </td>
                    <td style={tdStyle}>
                      {element.activityStatus.displayName}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {isActive && (
              <CSmartTable
                className="pt-3"
                items={GetChildByIndex(index)}
                columns={columnList}
                tableProps={{
                  hover: true,
                  responsive: true,
                }}
                scopedColumns={{
                  islemler: (item, number) => {
                    return (
                      <td className="py-2">
                        <CButton
                          className=" fw-semihold show-btn"
                          size="sm"
                          onClick={() => handleDownlaodButton(item?.item)}
                        >
                          Dosyayı İndir
                        </CButton>
                      </td>
                    );
                  },
                }}
              />
            )}
            {role.includes("Gözlemci") == 0 && role.includes("Öğrenci") == 0 && (
              <div>
                <ReactDropzone
                  formikFilesName="files"
                  labelText="Taslak Raporunu Yükleyiniz."
                  programFiles={programFiles}
                  setProgramFiles={setProgramFiles}
                  //submitButtonDisable={submitButtonDisable}
                  //setFieldValue={setFieldValue}
                  tusFiles={manageFileName}                
                  />
                <div className="w-full d-flex flex-row justify-content-end">
                  <CButton
                    onClick={() => sendIt()}
                    className="btn-success text-white"
                    //disabled={submitButtonDisable}
                  >
                    <CIcon icon={cilSend} className="me-1  " />
                    Dokümanı Yükle
                  </CButton>
                </div>
              </div>
            )}
          </CCardBody>
          {role.includes("Gözlemci") == 0 && role.includes("Öğrenci") == 0 && (
            <CCardFooter className="d-flex justify-content-end">
              <CButton
                onClick={() => {
                  if (programFiles.length == 0) {
                    Swal.fire({
                      title: "Hata",
                      text: "Taslak Raporu Yüklenmeden 30 Gün Yanıtı İsteyemezsiniz",
                    });
                  } else {
                    statuForward(element, updateVersion);
                  }
                }}
                className="btn-success text-white"
                disabled={submitButtonDisable}
              >
                <CIcon icon={cilSend} className="me-1  " />
                30 Gün Yanıtı İste
              </CButton>
            </CCardFooter>
          )}
        </CCard>
      )}
    </div>
  );
};

const tdStyle = {
  padding: 10,
  paddingInline: 20,
  alignItems: "center",
  textAlign: "center",
  margin: "0 auto",
};
const tdHeadStyle = {
  padding: 10,
  paddingInline: 20,
  alignItems: "center",
  textAlign: "center",
  margin: "0 auto",
  border: "2px solid black",
};

const columnList = [
  {
    key: "id",
    label: "Başvuru No",
    _style: { width: "15%" },
    _props: {}, // if no props, then _style is not used. Possible bug.
  },
  {
    key: "program",
    label: "Program",
    _style: { width: "25%" },
    _props: {},
  },

  {
    key: "creator",
    label: "Değerlendirici",
    _style: { width: "15%" },
    _props: {},
  },
  {
    key: "date",
    label: "Tarih",
    _style: { width: "15%" },
    _props: {},
  },
  {
    key: "status",
    label: "Dosya İsmi",
    _style: { width: "20%" },
    _props: {},
  },
  {
    key: "islemler",
    label: "İşlemler",
    _style: { width: "10%" },
    filter: false,
    sorter: false,
    _props: { className: "fw-semibold" },
  },
];
